import { render, staticRenderFns } from "./TicketCategory.vue?vue&type=template&id=ef80df3c&scoped=true"
import script from "./TicketCategory.vue?vue&type=script&lang=js"
export * from "./TicketCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef80df3c",
  null
  
)

export default component.exports